<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0">
                <div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
                    <div class="col-12 col-md-9 pl-0 mt-auto mb-auto">
                        <div class="col-12 pl-1 font-size-12 font-size-sm-10">Pengaturan</div>
                        <div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">Ubah Password</div>
                    </div>
                </div>
            </div>
            <div class="col-12 pl-0 pr-0 py-4">
                <div class="col-6 pl-0 pr-0 pb-2 rounded-cus bg-white overflow-hidden">
                    <div class="col-12 pt-3 font-size-10">
                        <div class="alert alert-primary mb-0 mt-3 font-size-10" role="alert">
                            <i class="fas fa-info-circle"></i> Ubah password secara berkala untuk tetap menjaga akun anda
                        </div>
                    </div>
                    <div class="col-12 pt-3">
                        <input class="form-control box-blue rounded-cus font-size-11" @focus="passClick('old')" @blur="passBlur('old')"
                            type="password" placeholder="Masukkan Password lama" v-model="oldPassword" id="old-password">
                        <span @click="showOldPassword" class="icon-password mr-4" :class="oldPass == true ? 'color-mila' : 'color-gray-2'">
                            <span v-show="sOldPassword"><i class="far fa-eye"></i></span>
                            <span v-show="!sOldPassword"><i class="far fa-eye-slash"></i></span>
                        </span>
                        <div class="invalid-feedback d-block m-0 pl-1" v-if="konfirmResponse.old_password">{{ konfirmResponse.old_password }} </div>
                    </div>
                    <div class="col-12 pt-3">
                        <input class="form-control box-blue rounded-cus font-size-11" @focus="passClick('new')" @blur="passBlur('new')"
                            type="password" placeholder="Masukkan password baru" v-model="newPassword" id="new-password" minlength="6">
                        <span @click="showNewPassword" class="icon-password mr-4" :class="newPass == true ? 'color-mila' : 'color-gray-2'">
                            <span v-show="sNewPassword"><i class="far fa-eye"></i></span>
                            <span v-show="!sNewPassword"><i class="far fa-eye-slash"></i></span>
                        </span>
                        <div class="invalid-feedback d-block m-0 pl-1" v-if="konfirmResponse.new_password">{{ konfirmResponse.new_password }} </div>
                    </div>
                    <div class="col-12 pt-3">
                        <input class="form-control box-blue rounded-cus font-size-11" @focus="passClick('conf')" @blur="passBlur('conf')"
                            type="password" placeholder="Masukkan konfirmasi password baru" v-model="confPassword" id="conf-password">
                        <span @click="showConfPassword" class="icon-password mr-4" :class="confPass == true ? 'color-mila' : 'color-gray-2'">
                            <span v-show="sConfPassword"><i class="far fa-eye"></i></span>
                            <span v-show="!sConfPassword"><i class="far fa-eye-slash"></i></span>
                        </span>
                        <div class="invalid-feedback d-block m-0 pl-1" v-if="konfirmResponse.new_password_conf">{{ konfirmResponse.new_password_conf }} </div>
                    </div>
                    <div class="col-12 pt-3 pb-2 d-flex justify-content-md-end">
                        <button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="submitPassword">
                            <div class="font-size-11 text-uppercase">Simpan</div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <i-modal ref="modalConfirmation" class="modal-small">
            <template v-slot:header>
                <div></div>
            </template>
            <template v-slot:body>
                <AlertModal title="Konfirmasi" message="Anda yakin akan mengubah password akun utama anda?" type="confirmation"
                    @remove="cancelPassword" @confirm="simpanPassword" />
            </template>
            <template v-slot:footer>
                <div class="footer-modal">
                    <div></div>
                </div>
            </template>
        </i-modal>
        <i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alert" :success="alertSuccess" type="alert" @remove="$refs.modalAlert.modalHide()"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
    </div>
</template>

<script>
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';

import { mapState, mapActions, mapMutations } from 'vuex';

export default {
    components: {
        IModal, AlertModal
    },
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            confPassword: '',
            sOldPassword: true,
            sNewPassword: true,
            sConfPassword: true,
            oldPass: false,
            newPass: false,
            confPass: false,
            modal_show: false,
            alert: '',
            alertSuccess: false
        }
    },
    computed: {
        ...mapState('auth', ['userData', 'is_have_pin']),
        ...mapState('profileList', ['responSukses', 'konfirmResponse']),
    },
    methods: {
        ...mapMutations('profileList', ['saveConfirmResponse']),
        ...mapActions('profileList', ['savePassword']),
        ...mapMutations('profileList', ['konfirmasiSukses']),

        submitPassword() {
            this.$refs.modalConfirmation.modalShow()
        },
        cancelPassword() {
            this.$refs.modalConfirmation.modalHide()
        },
        hideModalAlertSuccess() {
            this.$router.go()
        },
        simpanPassword() {
            const params = {
                old_password: this.oldPassword,
                new_password: this.newPassword,
                new_password_conf: this.confPassword
            }

            this.savePassword(params).then(() => {
                if(this.responSukses.code == 200){
                    this.alertSuccess = true
                    this.alert = this.responSukses.message
                    this.$refs.modalAlert.modalShow()
                    this.resetForm()
                } else if(this.konfirmResponse.code == 400){
                    this.alertSuccess = false
                    this.alert = this.konfirmResponse.message.msg
                    this.$refs.modalAlert.modalShow()
                }
                this.$refs.modalConfirmation.modalHide()
            })
        },
        passClick(type) {
            if (type == 'old')
                this.pass = true
            if (type == 'new')
                this.pass = true
            if (type == 'conf')
                this.pass = true
        },
        passBlur(type) {
            if (type == 'old') {
                if (this.oldPassword != "") {
                    this.oldPass = true
                } else {
                    this.oldPass = false
                }
            }
            if (type == 'new') {
                if (this.newPassword != "") {
                    this.newPass = true
                } else {
                    this.newPass = false
                }
            }
            if (type == 'conf') {
                if (this.confPassword != "") {
                    this.confPass = true
                } else {
                    this.confPass = false
                }
            }
        },
        showOldPassword() {
            var x = document.getElementById("old-password");
            if (x.type === "password") {
                x.type = "text"
                this.sOldPassword = false
            } else {
                x.type = "password"
                this.sOldPassword = true
            }
        },
        showNewPassword() {
            var x = document.getElementById("new-password");
            if (x.type === "password") {
                x.type = "text"
                this.sNewPassword = false
            } else {
                x.type = "password"
                this.sNewPassword = true
            }
        },
        showConfPassword() {
            var x = document.getElementById("conf-password");
            if (x.type === "password") {
                x.type = "text"
                this.sConfPassword = false
            } else {
                x.type = "password"
                this.sConfPassword = true
            }
        },
        resetForm(){
            this.oldPassword = ''
            this.newPassword = ''
            this.confPassword = ''
            this.sOldPassword = true
            this.sNewPassword = true
            this.sConfPassword = true
            this.oldPass = false
            this.newPass = false
            this.confPass = false
        }
    },
    created() {
        this.$store.dispatch('setPageTitle', 'Ubah Password');
    }
};
</script>
